import ListGroup from "react-bootstrap/ListGroup"
import Button from "react-bootstrap/Button"
import Card from "react-bootstrap/Card"
import { 
    InfoCircle, 
} from "react-bootstrap-icons"

import "./style.css"

type EMETLFieldManualCellProps = {
    children?: React.ReactNode,
    title?: string,
    subtitle?: string,
    onClick?: () => void,
    style?: React.CSSProperties,
    onHoverColor?: string,
    infoFunction?: () => void,
}

const EMETLFieldManualCell = (props?: EMETLFieldManualCellProps) => {
    const {
        children,
        title,
        subtitle,
        style,
        onClick,
        onHoverColor = "rgb(242, 242, 242)",
        infoFunction = () => {/**/},
    } = props

    const cardTitle = children ?? title
    const backgroundColor = style?.backgroundColor ?? "initial"

    return (
        <ListGroup.Item
            style={style ?? {}}
            onClick={onClick}
            onMouseOver={(e) => {
                e.currentTarget.style.cursor = "pointer"
                e.currentTarget.style.backgroundColor = onHoverColor
            }}
            onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = backgroundColor
            }}
        >
            <Card
                className="roundFit"
                style={ style ?? {} }
                onMouseOver={(e) => {
                    e.currentTarget.style.cursor = "pointer"
                    e.currentTarget.style.backgroundColor = onHoverColor
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = backgroundColor
                }}
            >
                <Card.Title>
                    {cardTitle}
                    {infoFunction && (
                        <a 
                            className="link-primary" 
                            onClick={(e) => {
                                e.stopPropagation()
                                infoFunction()
                            }} 
                            role="button"
                            style={{
                                marginLeft: "8px",
                            }}
                        >
                            <InfoCircle />
                        </a>
                    )}
                </Card.Title>
                <Card.Text>
                    {subtitle}
                </Card.Text>
            </Card>
        </ListGroup.Item>
    )
}

export default EMETLFieldManualCell